import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const routes = [
  // PC 端
  { path: '/login', component: () => import('@/views/Login.vue') },
  {
    path: '/',
    component: () => import('@/layout/MainLayout.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      { path: 'dashboard', name: '库存总览', component: () => import('@/views/Dashboard.vue'), meta: { roles: ['MANAGER', 'SALESPERSON'] } },
      { path: 'inventory/init', name: '期初初始化', component: () => import('@/views/InventoryInit.vue'), meta: { roles: ['MANAGER'] } },
      { path: 'inbound', name: '入库记账', component: () => import('@/views/Inbound.vue'), meta: { roles: ['MANAGER'] } },
      { path: 'outbound', name: '出库记账', component: () => import('@/views/Outbound.vue'), meta: { roles: ['MANAGER', 'SALESPERSON'] } },
      { path: 'returns', name: '退货记录', component: () => import('@/views/Returns.vue'), meta: { roles: ['MANAGER'] } },
      { path: 'customer', name: '客户列表', component: () => import('@/views/CustomerList.vue'), meta: { roles: ['MANAGER'] } },
      { path: 'supplier', name: '供应商列表', component: () => import('@/views/SupplierList.vue'), meta: { roles: ['MANAGER'] } },
      { path: 'category', name: '品类管理', component: () => import('@/views/CategoryList.vue'), meta: { roles: ['MANAGER'] } },
      { path: 'warehouse', name: '仓库管理', component: () => import('@/views/WarehouseList.vue'), meta: { roles: ['MANAGER'] } },
      { path: 'expense-item', name: '杂费项管理', component: () => import('@/views/ExpenseItemList.vue'), meta: { roles: ['MANAGER'] } },
      { path: 'ledger', name: '出入库流水', component: () => import('@/views/LedgerQuery.vue'), meta: { roles: ['MANAGER', 'SALESPERSON'] } },
      { path: 'reconcile', name: '对账中心', component: () => import('@/views/Reconcile.vue'), meta: { roles: ['MANAGER', 'SALESPERSON'] } },
      { path: 'receivable', name: '应收账款', component: () => import('@/views/Receivable.vue'), meta: { roles: ['MANAGER'] } },
      { path: 'user', name: '用户管理', component: () => import('@/views/UserManage.vue'), meta: { roles: ['MANAGER'] } },
      { path: 'help', name: '操作手册', component: () => import('@/views/Help.vue'), meta: { roles: ['MANAGER', 'SALESPERSON'] } }
    ]
  },
  // 移动端
  {
    path: '/mobile',
    component: () => import('@/mobile/App.vue'),
    children: [
      { path: 'login', name: 'MobileLogin', component: () => import('@/mobile/views/Login.vue') },
      {
        path: '',
        component: () => import('@/mobile/components/BottomTab.vue'),
        redirect: '/mobile/stock',
        children: [
          { path: 'stock', name: 'M_库存总览', component: () => import('@/mobile/views/Stock.vue'), meta: { requiresAuth: true, roles: ['MANAGER', 'SALESPERSON'] } },
          { path: 'inbound', name: 'M_入库记账', component: () => import('@/mobile/views/Inbound.vue'), meta: { requiresAuth: true, roles: ['MANAGER'] } },
          { path: 'outbound', name: 'M_出库记账', component: () => import('@/mobile/views/Outbound.vue'), meta: { requiresAuth: true, roles: ['MANAGER', 'SALESPERSON'] } },
          { path: 'more', name: 'M_更多', component: () => import('@/mobile/views/More.vue'), meta: { requiresAuth: true, roles: ['MANAGER', 'SALESPERSON'] } },
          { path: 'more/receivable', name: 'M_应收账款', component: () => import('@/mobile/views/Receivable.vue'), meta: { requiresAuth: true, roles: ['MANAGER'] } },
          { path: 'more/returns', name: 'M_退货记录', component: () => import('@/mobile/views/Returns.vue'), meta: { requiresAuth: true, roles: ['MANAGER'] } },
          { path: 'more/customer', name: 'M_客户列表', component: () => import('@/mobile/views/CustomerList.vue'), meta: { requiresAuth: true, roles: ['MANAGER'] } },
          { path: 'more/supplier', name: 'M_供应商列表', component: () => import('@/mobile/views/SupplierList.vue'), meta: { requiresAuth: true, roles: ['MANAGER'] } },
          { path: 'more/category', name: 'M_品类管理', component: () => import('@/mobile/views/CategoryList.vue'), meta: { requiresAuth: true, roles: ['MANAGER'] } },
          { path: 'more/warehouse', name: 'M_仓库管理', component: () => import('@/mobile/views/WarehouseList.vue'), meta: { requiresAuth: true, roles: ['MANAGER'] } },
          { path: 'more/ledger', name: 'M_出入库流水', component: () => import('@/mobile/views/LedgerQuery.vue'), meta: { requiresAuth: true, roles: ['MANAGER', 'SALESPERSON'] } },
          { path: 'more/reconcile', name: 'M_对账中心', component: () => import('@/mobile/views/Reconcile.vue'), meta: { requiresAuth: true, roles: ['MANAGER', 'SALESPERSON'] } },
          { path: 'more/user', name: 'M_用户管理', component: () => import('@/mobile/views/UserManage.vue'), meta: { requiresAuth: true, roles: ['MANAGER'] } },
          { path: 'more/init', name: 'M_期初初始化', component: () => import('@/mobile/views/InventoryInit.vue'), meta: { requiresAuth: true, roles: ['MANAGER'] } },
          { path: 'more/help', name: 'M_操作手册', component: () => import('@/mobile/views/Help.vue'), meta: { requiresAuth: true, roles: ['MANAGER', 'SALESPERSON'] } }
        ]
      }
    ]
  }
]

const router = new Router({ routes })

router.beforeEach((to, from, next) => {
  const token = store.state.user.token
  const isMobile = to.path.startsWith('/mobile/')

  if (isMobile) {
    // 移动端登录页不需要 token
    if (to.path === '/mobile/login') {
      next()
      return
    }
    // 移动端其他页面需要 token
    if (!token) {
      next('/mobile/login')
      return
    }
    // 移动端角色权限检查（参照 PC 端路由的 roles 元数据）
    const role = store.state.user.role
    if (to.meta.roles && !to.meta.roles.includes(role)) {
      next('/mobile/stock')
      return
    }
    next()
    return
  }

  // PC 端路由守卫：非 /login 的 PC 页面都需要登录
  if (to.path === '/login') {
    if (token) {
      next('/dashboard')
    } else {
      next()
    }
  } else {
    // 所有非登录、非移动端路径都需要 token
    if (!token) {
      next('/login')
    } else {
      const role = store.state.user.role
      if (to.meta.roles && !to.meta.roles.includes(role)) {
        next('/dashboard')
      } else {
        next()
      }
    }
  }
})

// 全局捕获导航错误（如路由守卫中重复跳转导致的 cancelled 错误）
router.onError(error => {
  console.warn('Router error:', error.message)
})

export default router
